<template>
    <div>
        <connection-name ref="name" :value="name" @input="$emit('update:name', $event)" />

        <connection-start-date :value="startDate" @input="$emit('update:startDate', $event)" />
        <toggle :value="isDisabled" @input="$emit('update:isDisabled', $event)" :label="resource('Bool_Disabled')"/>
        <connection-delay :value="delay" @input="$emit('update:delay', $event)"/>

        <connection-email v-if="isEmail && emailCampaigns.length !== 0" :value="emailCampaign" @input="$emit('update:emailCampaign', $event)" :options="emailCampaigns" />
        <connection-steam v-if="isTm && steamCampaigns.length !== 0" :value="steamCampaign" @input="$emit('update:steamCampaign', $event)" :options="steamCampaigns" />
        <toggle v-if="isFacebook" :value="groupByTitle" @input="$emit('update:groupByTitle', $event)" :label="resource('JourneyBuilder_FilterSettings_GroupByTitle')"/>
        
        <connection-actions 
            v-if="availableActionConditions.length != 0" 
            :value="actionConditions"
            @input="$emit('update:actionConditions', $event)"
            :connectionId="id" 
            :conditions="availableActionConditions"
        />
        
        <connection-content v-if="!hideContentSettings" ref="contentSettings" :value="contentSettings" @input="$emit('update:contentSettings', $event)" :options="availableMidConditions" />
    </div>
</template>

<script>
import flags from '../../../flags';
import {conditionTypes} from "../../../ConnectionSettings/condition-types";
import {subTypes} from '../../../Bricks/brick-types';

import resources from '../../../../../Util/Mixins/resources';
import permissionsMixin from '../../../Mixins/journey-permissions';

import JourneyConnectionActions from './GeneralSettings/JourneyConnectionActions.vue';
import JourneyConnectionName from './GeneralSettings/JourneyConnectionName.vue';
import JourneyConnectionContent from './GeneralSettings/JourneyConnectionContent.vue';
import JourneyConnectionDate from './GeneralSettings/JourneyConnectionStartDate.vue'
import JourneyConnectionToggle from "./JourneyConnectionToggle.vue";
import JourneyConnectionDelay from './GeneralSettings/JourneyConnectionDelay.vue';
import JourneyConnectionEmailCampaign from './GeneralSettings/JourneyConnectionEmailCampaign.vue';
import JourneyConnectionSteamCampaign from './GeneralSettings/JourneyConnectionSteamCampaign.vue';

export default {
    name: 'journey-connection-general-settings',
    components: {
        'ConnectionActions': JourneyConnectionActions,
        'ConnectionName': JourneyConnectionName,
        'Toggle': JourneyConnectionToggle,
        'ConnectionStartDate': JourneyConnectionDate,
        'ConnectionContent': JourneyConnectionContent,
        'ConnectionEmail': JourneyConnectionEmailCampaign,
        'ConnectionSteam': JourneyConnectionSteamCampaign,
        'ConnectionDelay': JourneyConnectionDelay
    },
    mixins: [resources, permissionsMixin],
    mounted() {
        this.validate();
    },
    methods: {
        validate(){
            this.isValid = this.validateContentSettings() && this.validateName();
        },
        validateContentSettings(){
            //Can't be edited for the time being
            if(flags.hideContentSettings){
                return true;
            }

            //We haven't rendered yet
            if(!this.$refs.contentSettings){
                return true;
            }

            return !this.$refs.contentSettings.$v.$invalid;
        },
        validateName(){
            //We haven't rendered yet
            if(!this.$refs.name){
                return true;
            }

            return !this.$refs.name.$v.$invalid;
        }
    },
    watch: {
        name() { this.validate() },
        startDate() { this.validate() },
        isDisabled() { this.validate() },
        actionConditions: {
            handler(){
                this.validate()
            },
            deep: true
        },
        contentSettings: { 
            handler(){
                this.validate()
            },
            deep: true
        },

        isValid(value){
            this.$emit('validated', value);
        }
    },
    computed: {
        id(){
            return this.connection.id;
        },
        availableMidConditions(){
            //Not implemented for the time being
            return [];
        },
        isEmail() {
            const config = this.connection.destinationBrick.config;
            return config != null && config.touchpointParentType === subTypes.email;
        },
        isTm() {
            const config = this.connection.destinationBrick.config;
            return config != null && config.touchpointParentType === subTypes.tm;
        },
        isFacebook() {
            const config = this.connection.destinationBrick.config;
            return config != null && config.touchpointParentType === subTypes.fb;
        }
    },
    data() {
        return {
            isValid: false,
            hideContentSettings: flags.hideContentSettings
        };
    },
    props: {
        connection: {
            type: Object,
            required: true
        },
        availableConditions: {
            type: Array,
            required: true
        },
        name: String,
        startDate: String,
        isDisabled: Boolean,
        delay: Object,
        steamCampaign: Object,
        emailCampaign: Object,
        groupByTitle: Boolean,
        actionConditions: Array,
        contentSettings: Array,
        availableActionConditions: Array,
        emailCampaigns: Array,
        steamCampaigns: Array
    }
};
</script>

<style lang="scss" scoped>

</style>
